__turbopack_context__.v({
  "counter": "feedback-module-scss-module__zMKtWq__counter",
  "description": "feedback-module-scss-module__zMKtWq__description",
  "feedback_input": "feedback-module-scss-module__zMKtWq__feedback_input",
  "optionalLabel": "feedback-module-scss-module__zMKtWq__optionalLabel",
  "textArea": "feedback-module-scss-module__zMKtWq__textArea",
  "title": "feedback-module-scss-module__zMKtWq__title",
  "version_description": "feedback-module-scss-module__zMKtWq__version_description",
  "version_input": "feedback-module-scss-module__zMKtWq__version_input",
});
